
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree2ae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree2ae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gYOZo", function(module, exports) {
module.exports = JSON.parse('[{"name":"Soldador Azul","info":"Guante de carnaza de res con tratamiento a base de aceite, dise\xf1ado para trabajos de soldadura y manejo de materiales calientes. Costuras con hilo Kevlar que ofrecen alta resistencia al calor. Incluye refuerzo en la palma para mayor durabilidad.","specs":{"Material":"Carnaza de res","Tratamiento":"A base de aceite","Forro":"Fieltro blanco (calibre 100\u2013120)","Costuras":"Hilo Kevlar","Refuerzo":"Palma reforzada","Longitud":"14 pulgadas"},"category":"soldadura","imgs":["Soldador_azul_2.webp","Soldador_azul_3.webp","Soldador_azul_par.webp"],"materials":["carnaza"],"colors":{"tag":"color","values":["azul"]}},{"name":"Soldador Rojo","info":"Guante de carnaza de res con tratamiento a base de aceite, dise\xf1ado para trabajos de soldadura y manejo de materiales calientes. Costuras con hilo Kevlar que ofrecen alta resistencia al calor.","specs":{"Material":"Carnaza de res","Tratamiento":"A base de aceite","Forro":"Fieltro blanco (calibre 100\u2013120)","Costuras":"Hilo Kevlar","Longitud":"14 pulgadas"},"category":"soldadura","imgs":["Soldador_rojo.webp","Soldador_rojo_2.webp","Soldador_rojo_3.webp","Soldador_rojo_par.webp"],"materials":["carnaza"],"colors":{"tag":"color","values":["rojo"]}},{"name":"Soldador Gris","info":"Guante de carnaza de res con tratamiento a base de aceite, dise\xf1ado para trabajos de soldadura y manejo de materiales calientes. Costuras con hilo de resistencia est\xe1ndar.","specs":{"Material":"Carnaza de res","Tratamiento":"A base de aceite","Forro":"Fieltro blanco (calibre 100\u2013120)","Costuras":"Hilo est\xe1ndar","Longitud":"14 pulgadas"},"category":"soldadura","imgs":["Soldador_gris.webp","Soldador_gris_2.webp","Soldador_gris_3.webp","Soldador_gris_par.webp"],"materials":["carnaza"],"colors":{"tag":"color","values":["gris"]}},{"name":"Argonero de piel","info":"Guante fabricado en piel de res de alta calidad, dise\xf1ado para ofrecer excelente durabilidad y comodidad. Cuenta con tira ajustable con broche que brinda un ajuste seguro. Incorpora bies rojo en el pu\xf1o para mayor refuerzo.","specs":{"Material":"Piel de res","Dise\xf1o":"Argonero","Ajuste":"Tira ajustable con broche","Acabado":"Bies rojo en pu\xf1o","Largo":"24 cm","Ancho":"13 cm"},"category":"argon","materials":["piel"],"imgs":["Argonero_de_piel.webp","Argonero_de_piel_2.webp","Argonero_de_piel_3.webp","Argonero_de_piel_4.webp"],"colors":{"tag":"color","values":["amarillo natural"]}},{"name":"Argonero el\xe1stico","info":"Guante fabricado en piel de res de alta calidad, dise\xf1ado para ofrecer excelente durabilidad y comodidad. Cuenta con el\xe1stico en la mu\xf1eca que brinda un ajuste seguro y c\xf3modo. Incorpora bies rojo en el pu\xf1o para mayor refuerzo.","specs":{"Material":"Piel de res","Dise\xf1o":"Argonero","Ajuste":"El\xe1stico en mu\xf1eca","Acabado":"Bies rojo en pu\xf1o","Largo":"24 cm","Ancho":"13 cm"},"category":"argon","materials":["piel"],"imgs":["Argonero_elastico.webp","Argonero_elastico_2.webp"],"colors":{"tag":"color","values":["amarillo natural"]}},{"name":"Operador","info":"Guante fabricado en piel de res de alta calidad con dise\xf1o tipo operador que permite un ajuste ergon\xf3mico y acabado suave. Cuenta con tira ajustable con broche para un ajuste seguro y personalizado. Incorpora bies rojo en el pu\xf1o para mayor refuerzo.","specs":{"Material":"Piel de res","Dise\xf1o":"Tipo operador","Ajuste":"Tira ajustable con broche","Acabado":"Bies rojo en pu\xf1o","Largo":"24 cm","Ancho":"13 cm"},"category":"trabajo-general","materials":["piel"],"imgs":["Operador.webp","Operador_2.webp","Operador_3.webp","Operador_4.webp"],"colors":{"tag":"color","values":["amarillo natural"]}}]');

});

parcelRegister("l7uIn", function(module, exports) {

$parcel$export(module.exports, "images", () => $f60213bb42844d9b$export$6c746a5570b8b35c);
$parcel$export(module.exports, "categoryNames", () => $f60213bb42844d9b$export$135fbf9c72b475d8);
$parcel$export(module.exports, "elementToCard", () => $f60213bb42844d9b$export$5fdc05e0f5efaf36);
$parcel$export(module.exports, "soldadorTable", () => $f60213bb42844d9b$export$57502b0d84861955);

var $hTqAC = parcelRequire("hTqAC");






















const $f60213bb42844d9b$export$6c746a5570b8b35c = {
    'Argonero_de_piel.webp': new URL((parcelRequire("7SNYy"))).href,
    'Argonero_de_piel_2.webp': new URL((parcelRequire("1zJwR"))).href,
    'Argonero_de_piel_4.webp': new URL((parcelRequire("3olXa"))).href,
    'Argonero_de_piel_3.webp': new URL((parcelRequire("gNjTO"))).href,
    'Argonero_elastico.webp': new URL((parcelRequire("euzJw"))).href,
    'Argonero_elastico_2.webp': new URL((parcelRequire("6aHbB"))).href,
    'Operador.webp': new URL((parcelRequire("h7p0p"))).href,
    'Operador_2.webp': new URL((parcelRequire("i9w2I"))).href,
    'Operador_3.webp': new URL((parcelRequire("37vTM"))).href,
    'Operador_4.webp': new URL((parcelRequire("cPTrC"))).href,
    'Soldador_gris.webp': new URL((parcelRequire("gUe5U"))).href,
    'Soldador_gris_2.webp': new URL((parcelRequire("7aVdV"))).href,
    'Soldador_gris_3.webp': new URL((parcelRequire("1I3kA"))).href,
    'Soldador_gris_par.webp': new URL((parcelRequire("3BBA3"))).href,
    'Soldador_azul.webp': new URL((parcelRequire("lr9Z7"))).href,
    'Soldador_azul_2.webp': new URL((parcelRequire("4qz8A"))).href,
    'Soldador_azul_3.webp': new URL((parcelRequire("K8QHP"))).href,
    'Soldador_azul_par.webp': new URL((parcelRequire("2flBv"))).href,
    'Soldador_rojo.webp': new URL((parcelRequire("b34xM"))).href,
    'Soldador_rojo_2.webp': new URL((parcelRequire("lymLx"))).href,
    'Soldador_rojo_3.webp': new URL((parcelRequire("2eDyz"))).href,
    'Soldador_rojo_par.webp': new URL((parcelRequire("c2qNY"))).href
};
const $f60213bb42844d9b$export$135fbf9c72b475d8 = {
    soldadura: 'Soldadura',
    argon: "Arg\xf3n",
    'trabajo-general': 'Trabajo general'
};
const $f60213bb42844d9b$export$f98002053ad6dda2 = {
    azul: '#224575',
    rojo: '#943329',
    gris: '#8a8380',
    'amarillo natural': '#d19a3a'
};
function $f60213bb42844d9b$export$be56b7e53123b17a(product) {
    return './producto.html?ver=' + encodeURIComponent(product.name);
}
function $f60213bb42844d9b$export$ff0eb67b170646b7(product) {
    var color = product.colors && product.colors.values[0];
    return $f60213bb42844d9b$export$f98002053ad6dda2[color] ? '<span class="color-dot" style="--swatch:' + $f60213bb42844d9b$export$f98002053ad6dda2[color] + '" title="' + color + '"></span>' : '';
}
function $f60213bb42844d9b$export$5fdc05e0f5efaf36(product, index) {
    var productUrl = $f60213bb42844d9b$export$be56b7e53123b17a(product);
    var photo = product.imgs.find(function(name) {
        return name.includes('_par');
    }) || product.imgs[0];
    var hoverPhoto = product.imgs.find(function(name) {
        return name !== photo;
    });
    var position = typeof index === 'number' ? '<span class="card-index">' + String(index + 1).padStart(2, '0') + '</span>' : '';
    var facts = [
        [
            'Material',
            product.specs.Material
        ],
        [
            'Longitud',
            product.specs.Longitud || product.specs.Largo
        ],
        [
            product.specs.Costuras ? 'Costuras' : 'Ajuste',
            product.specs.Costuras || product.specs.Ajuste
        ]
    ];
    return `
    <article class="catalog-card wow" data-category="${product.category}">
        <div class="card">
            <a href="${productUrl}" class="card-image-link" aria-label="Ver ficha de ${product.name}">
                <span class="card-category">${$f60213bb42844d9b$export$135fbf9c72b475d8[product.category]}</span>
                <img src="${$f60213bb42844d9b$export$6c746a5570b8b35c[photo]}" alt="${product.name}, vista del producto" loading="lazy" decoding="async" width="400" height="280">
                ${hoverPhoto ? '<img class="card-hover-image" src="' + $f60213bb42844d9b$export$6c746a5570b8b35c[hoverPhoto] + '" alt="" loading="lazy" decoding="async" width="400" height="280">' : ''}
                ${position}
            </a>
            <div class="card-content">
                <h3 class="card-product-title">${$f60213bb42844d9b$export$ff0eb67b170646b7(product)}<a href="${productUrl}">${product.name}</a></h3>
                <dl class="card-facts">${facts.map(function([label, value]) {
        return '<div><dt>' + label + '</dt><dd>' + value + '</dd></div>';
    }).join('')}</dl>
                ${product.specs.Refuerzo ? '<p class="variant-note">' + product.specs.Refuerzo + '</p>' : ''}
                <div class="card-actions">
                    <a href="${productUrl}" class="text-link" aria-label="Ver ficha de ${product.name}">Ver ficha \u{2197}</a>
                    <a href="${(0, $hTqAC.buildQuoteUrl)(product.name)}" class="button is-warning" target="_blank" rel="noopener noreferrer" aria-label="Cotizar ${product.name} por WhatsApp">Cotizar \u{2197}</a>
                </div>
            </div>
        </div>
    </article>`;
}
const $f60213bb42844d9b$export$cf53f8da0aa21d72 = [
    'Costuras',
    'Refuerzo',
    'Forro',
    'Longitud'
];
function $f60213bb42844d9b$export$57502b0d84861955(products, current) {
    var models = products.filter(function(glove) {
        return glove.category === 'soldadura';
    });
    var head = models.map(function(glove) {
        var name = glove === current ? glove.name + ' <small>(este modelo)</small>' : '<a href="' + $f60213bb42844d9b$export$be56b7e53123b17a(glove) + '">' + glove.name + '</a>';
        return '<th scope="col"' + (glove === current ? ' aria-current="page"' : '') + '>' + $f60213bb42844d9b$export$ff0eb67b170646b7(glove) + name + '</th>';
    }).join('');
    var rows = $f60213bb42844d9b$export$cf53f8da0aa21d72.map(function(key) {
        return '<tr><th scope="row">' + key + '</th>' + models.map(function(glove) {
            var value = glove.specs[key];
            return '<td' + (value ? '' : ' class="is-empty"') + '>' + (value || 'No especificado') + '</td>';
        }).join('') + '</tr>';
    }).join('');
    var actions = '<tr class="compare-actions"><th scope="row">Cotizar</th>' + models.map(function(glove) {
        return '<td><a href="' + (0, $hTqAC.buildQuoteUrl)(glove.name) + '" class="button is-warning" target="_blank" rel="noopener noreferrer" aria-label="Cotizar ' + glove.name + ' por WhatsApp">Cotizar \u2197</a></td>';
    }).join('') + '</tr>';
    return '<div class="compare-scroll"><table class="compare-table"><caption class="is-sr-only">Comparaci\xf3n de los modelos de soldador</caption><thead><tr><th scope="col"><span class="is-sr-only">Dato</span></th>' + head + '</tr></thead><tbody>' + rows + actions + '</tbody></table></div>';
}

});
parcelRegister("hTqAC", function(module, exports) {

$parcel$export(module.exports, "validQuantity", () => $d06c32ded3014aa3$export$6ea8ebd578e5ebfd);
$parcel$export(module.exports, "buildQuoteUrl", () => $d06c32ded3014aa3$export$c1bf0ec16038ee7d);
$parcel$export(module.exports, "bindQuoteLinks", () => $d06c32ded3014aa3$export$c585aa1941e83dc5);
$parcel$export(module.exports, "initQuoteForm", () => $d06c32ded3014aa3$export$d52eb421dd65a26e);
function $d06c32ded3014aa3$export$6ea8ebd578e5ebfd(value) {
    return value === '' || /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0;
}
function $d06c32ded3014aa3$export$c1bf0ec16038ee7d(model = '', quantity = '') {
    var message = model ? 'Hola, quiero cotizar el guante ' + model + '.' : 'Hola, quiero cotizar guantes para mi equipo.';
    if (quantity !== '' && $d06c32ded3014aa3$export$6ea8ebd578e5ebfd(quantity)) message += ' Cantidad: ' + quantity + ' pares.';
    if (!model) message += " \xbfMe ayudan a elegir un modelo?";
    return 'https://wa.me/524311032726?text=' + encodeURIComponent(message);
}
function $d06c32ded3014aa3$export$c585aa1941e83dc5(model, quantity, links) {
    function update() {
        quantity.setCustomValidity('');
        var name = typeof model === 'string' ? model : model.value;
        links.forEach(function(link) {
            link.href = $d06c32ded3014aa3$export$c1bf0ec16038ee7d(name, quantity.value);
        });
    }
    quantity.addEventListener('input', update);
    if (typeof model !== 'string') model.addEventListener('change', update);
    links.forEach(function(link) {
        link.addEventListener('click', function(event) {
            quantity.setCustomValidity($d06c32ded3014aa3$export$6ea8ebd578e5ebfd(quantity.value) ? '' : 'Ingresa una cantidad entera mayor que cero.');
            if (!quantity.reportValidity()) event.preventDefault();
        });
    });
    update();
    return update;
}
function $d06c32ded3014aa3$export$d52eb421dd65a26e() {
    var form = /** @type {HTMLFormElement | null} */ document.getElementById('contact-form');
    if (!form) return;
    var model = /** @type {HTMLSelectElement} */ form.elements.namedItem('model');
    var quantity = /** @type {HTMLInputElement} */ form.elements.namedItem('quantity');
    var update = $d06c32ded3014aa3$export$c585aa1941e83dc5(model, quantity, form.querySelectorAll('.quote-contact-link'));
    form.addEventListener('reset', function() {
        setTimeout(update, 0);
    });
}

});

parcelRegister("7SNYy", function(module, exports) {
module.exports = import.meta.resolve("kVjUu");

});

parcelRegister("1zJwR", function(module, exports) {
module.exports = import.meta.resolve("5Ky23");

});

parcelRegister("3olXa", function(module, exports) {
module.exports = import.meta.resolve("2Ha9L");

});

parcelRegister("gNjTO", function(module, exports) {
module.exports = import.meta.resolve("5Uhx2");

});

parcelRegister("euzJw", function(module, exports) {
module.exports = import.meta.resolve("5nxti");

});

parcelRegister("6aHbB", function(module, exports) {
module.exports = import.meta.resolve("eAqK1");

});

parcelRegister("h7p0p", function(module, exports) {
module.exports = import.meta.resolve("e8z96");

});

parcelRegister("i9w2I", function(module, exports) {
module.exports = import.meta.resolve("boQ1I");

});

parcelRegister("37vTM", function(module, exports) {
module.exports = import.meta.resolve("fl4aN");

});

parcelRegister("cPTrC", function(module, exports) {
module.exports = import.meta.resolve("8DBN8");

});

parcelRegister("gUe5U", function(module, exports) {
module.exports = import.meta.resolve("ia1ZY");

});

parcelRegister("7aVdV", function(module, exports) {
module.exports = import.meta.resolve("hLyKv");

});

parcelRegister("1I3kA", function(module, exports) {
module.exports = import.meta.resolve("fH036");

});

parcelRegister("3BBA3", function(module, exports) {
module.exports = import.meta.resolve("8LeHw");

});

parcelRegister("lr9Z7", function(module, exports) {
module.exports = import.meta.resolve("fpf82");

});

parcelRegister("4qz8A", function(module, exports) {
module.exports = import.meta.resolve("in53s");

});

parcelRegister("K8QHP", function(module, exports) {
module.exports = import.meta.resolve("bBQNa");

});

parcelRegister("2flBv", function(module, exports) {
module.exports = import.meta.resolve("coj1k");

});

parcelRegister("b34xM", function(module, exports) {
module.exports = import.meta.resolve("gTJbL");

});

parcelRegister("lymLx", function(module, exports) {
module.exports = import.meta.resolve("7LAN1");

});

parcelRegister("2eDyz", function(module, exports) {
module.exports = import.meta.resolve("457B2");

});

parcelRegister("c2qNY", function(module, exports) {
module.exports = import.meta.resolve("1Hghz");

});


parcelRegister("cVp72", function(module, exports) {

$parcel$export(module.exports, "initReveal", () => $968e49bc9b5b83e7$export$8175101c94c0e570);
/**
 * Lightweight, dependency-free reveal-on-scroll using IntersectionObserver.
 * Replaces the deprecated wow.js library.
 * Honors prefers-reduced-motion and supports dynamic content.
 */ function $968e49bc9b5b83e7$export$8175101c94c0e570(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var container = root || document;
    var elements = container.querySelectorAll('.wow:not(.is-visible):not([data-reveal-observed])');
    if (!elements.length) return;
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var el = entry.target;
                var delayAttr = el.getAttribute('data-reveal-delay') || el.getAttribute('data-wow-delay') || '0';
                var delay = Math.round(parseFloat(delayAttr) * 1000);
                setTimeout(function() {
                    el.classList.add('is-visible');
                }, delay);
                observer.unobserve(el);
            }
        });
    }, {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px'
    });
    elements.forEach(function(el) {
        el.setAttribute('data-reveal-observed', '');
        observer.observe(el);
    });
    return observer;
}

});


var $gYOZo = parcelRequire("gYOZo");

var $l7uIn = parcelRequire("l7uIn");

var $cVp72 = parcelRequire("cVp72");

var $hTqAC = parcelRequire("hTqAC");
var $aabb1e7634dec432$var$name = new URLSearchParams(window.location.search).get('ver');
var $aabb1e7634dec432$var$product = (0, (/*@__PURE__*/$parcel$interopDefault($gYOZo))).find(function(glove) {
    return glove.name === $aabb1e7634dec432$var$name;
});
var $aabb1e7634dec432$var$container = document.getElementById('product');
$aabb1e7634dec432$var$container.setAttribute('aria-busy', 'false');
if (!$aabb1e7634dec432$var$product) {
    document.title = "Producto no encontrado | Guantes Guti\xe9rrez";
    document.querySelector('meta[name="robots"]').content = 'noindex, follow';
    $aabb1e7634dec432$var$container.innerHTML = '<div class="notification"><h1 class="section-title">Producto no encontrado</h1><p>Este modelo no est\xe1 en nuestro cat\xe1logo.</p><a class="text-link" href="./#catalogo">Volver al cat\xe1logo \u2197</a></div>';
} else $aabb1e7634dec432$var$renderProduct($aabb1e7634dec432$var$product);
function $aabb1e7634dec432$var$renderProduct(product) {
    var pageUrl = new URL('producto.html', 'https://guantesgutierrez.com/');
    pageUrl.searchParams.set('ver', product.name);
    var description = product.info;
    var productImages = product.imgs.map(function(photo) {
        return (0, $l7uIn.images)[photo];
    });
    var variants = product.category === 'soldadura' ? (0, (/*@__PURE__*/$parcel$interopDefault($gYOZo))).filter(function(glove) {
        return glove.category === product.category;
    }) : [];
    var swatches = {
        'Soldador Azul': '#224575',
        'Soldador Rojo': '#943329',
        'Soldador Gris': '#8a8380'
    };
    document.title = product.name + " | Guantes Guti\xe9rrez";
    var productionImages = productImages.map(function(image) {
        return new URL(new URL(image).pathname, pageUrl).href;
    });
    var meta = {
        'meta[name="description"]': description,
        'meta[property="og:title"]': document.title,
        'meta[property="og:description"]': description,
        'meta[property="og:url"]': pageUrl.href,
        'meta[property="og:image"]': productionImages[0],
        'meta[property="twitter:title"]': document.title,
        'meta[property="twitter:description"]': description,
        'meta[property="twitter:url"]': pageUrl.href,
        'meta[property="twitter:image"]': productionImages[0]
    };
    Object.entries(meta).forEach(function([selector, value]) {
        var el = document.querySelector(selector);
        if (el) el.content = value;
    });
    document.querySelector('link[rel="canonical"]').href = pageUrl.href;
    $aabb1e7634dec432$var$container.innerHTML = `
        <nav class="product-breadcrumb" aria-label="Ruta de navegaci\xf3n"><a href="./">Inicio</a><span aria-hidden="true">/</span><a href="./#catalogo">Cat\xe1logo</a><span aria-hidden="true">/</span><span aria-current="page">${product.name}</span></nav>
        <div class="product-detail">
            <div class="product-gallery" role="group" aria-label="Fotograf\xedas de ${product.name}">
                <div class="gallery-stage">
                    <button type="button" class="gallery-image-button" aria-label="Ampliar fotograf\xeda de ${product.name}"><img id="gallery-image" src="${productImages[0]}" alt="${product.name}, fotograf\xeda 1 de ${productImages.length}" width="480" height="400" fetchpriority="high"></button>
                    <div class="gallery-controls"><button type="button" data-direction="-1" aria-label="Fotograf\xeda anterior">\u{2190}</button><span id="gallery-counter" role="status">1 / ${productImages.length} \xb7 Toca para ampliar</span><button type="button" data-direction="1" aria-label="Fotograf\xeda siguiente">\u{2192}</button></div>
                </div>
                <div class="gallery-thumbs">${productImages.map(function(image, index) {
        return '<button type="button" data-photo="' + index + '" aria-label="Ver fotograf\xeda ' + (index + 1) + '" aria-pressed="' + (index === 0) + '"><img src="' + image + '" alt="" width="64" height="64" loading="lazy"></button>';
    }).join('')}</div>
            </div>
            <div class="product-info">
                <p class="section-label">${(0, $l7uIn.categoryNames)[product.category]} \xb7 Guantes Guti\xe9rrez</p><h1 class="product-title">${product.name}</h1><p class="product-description">${description}</p>
                ${variants.length ? '<p class="label">Compara modelos de soldador</p><div class="variant-links">' + variants.map(function(glove) {
        return '<a class="variant-link" href="./producto.html?ver=' + encodeURIComponent(glove.name) + '"' + (glove === product ? ' aria-current="page"' : '') + '><span class="color-dot" style="--swatch:' + swatches[glove.name] + '" aria-hidden="true"></span>' + glove.name.replace('Soldador ', '') + '</a>';
    }).join('') + '</div><p class="variant-note">Cada modelo tiene especificaciones distintas. Compara costuras y refuerzo antes de elegir.</p>' : ''}
                ${variants.length ? '<details class="compare-details"><summary>Ver comparaci\xf3n de los tres soldadores</summary>' + (0, $l7uIn.soldadorTable)((0, (/*@__PURE__*/$parcel$interopDefault($gYOZo))), product) + '</details>' : ''}
                <h2 class="label">Ficha t\xe9cnica</h2><table class="product-specs-table"><caption class="is-sr-only">Especificaciones de ${product.name}</caption><tbody>${Object.entries(product.specs).map(function([key, value]) {
        return '<tr><th scope="row">' + key + '</th><td>' + value + '</td></tr>';
    }).join('')}</tbody></table>
                <div class="product-quote">
                    <label class="label" for="product-quantity">Cantidad de pares</label><input class="input quantity-input" type="number" min="1" step="1" required id="product-quantity" inputmode="numeric">
                    <div class="product-quote-actions"><a href="${(0, $hTqAC.buildQuoteUrl)(product.name)}" class="button is-warning product-quote-link" target="_blank" rel="noopener noreferrer">Cotizar por WhatsApp \u{2197}</a><a href="#contacto" class="text-link">Prefiero correo</a></div>
                    <p class="variant-note">Consulta disponibilidad, precios por volumen y env\xedo antes de confirmar tu pedido.</p>
                </div>
            </div>
        </div>
        <dialog class="product-dialog" aria-labelledby="photo-dialog-title"><div class="dialog-header"><h2 id="photo-dialog-title">${product.name}</h2><button type="button" class="button is-outlined dialog-close">Cerrar \xd7</button></div><img alt="${product.name}, fotograf\xeda ampliada"></dialog>
    `;
    document.body.classList.add('has-product-quote');
    document.body.insertAdjacentHTML('beforeend', '<div class="mobile-quote-bar"><div class="mobile-quote-model"><strong>' + product.name + '</strong><span>Indica la cantidad</span></div><label class="is-sr-only" for="mobile-quantity">Cantidad de pares</label><input class="input quantity-input" id="mobile-quantity" type="number" min="1" step="1" inputmode="numeric" required placeholder="Pares" aria-label="Cantidad de pares"><a class="button is-warning product-quote-link" href="' + (0, $hTqAC.buildQuoteUrl)(product.name) + '" target="_blank" rel="noopener noreferrer" aria-label="Cotizar ' + product.name + ' por WhatsApp">Cotizar \u2197</a></div>');
    var quantity = document.getElementById('product-quantity');
    var mobileQuantity = document.getElementById('mobile-quantity');
    (0, $hTqAC.bindQuoteLinks)(product.name, quantity, [
        $aabb1e7634dec432$var$container.querySelector('.product-quote-link')
    ]);
    (0, $hTqAC.bindQuoteLinks)(product.name, mobileQuantity, [
        document.querySelector('.mobile-quote-bar .product-quote-link')
    ]);
    [
        quantity,
        mobileQuantity
    ].forEach(function(source) {
        source.addEventListener('input', function() {
            var other = source === quantity ? mobileQuantity : quantity;
            other.value = source.value;
            other.dispatchEvent(new Event('input', {
                bubbles: false
            }));
        });
    });
    var modelSelect = document.getElementById('quote-model');
    modelSelect.value = product.name;
    modelSelect.dispatchEvent(new Event('change', {
        bubbles: true
    }));
    $aabb1e7634dec432$var$container.querySelector('a[href="#contacto"]').addEventListener('click', function() {
        var contactQuantity = document.getElementById('quote-quantity');
        contactQuantity.value = quantity.value;
        contactQuantity.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    });
    var gallery = $aabb1e7634dec432$var$container.querySelector('.product-gallery');
    var photoIndex = 0;
    var mainImage = document.getElementById('gallery-image');
    var thumbs = gallery.querySelectorAll('[data-photo]');
    var dialog = $aabb1e7634dec432$var$container.querySelector('.product-dialog');
    function showPhoto(index) {
        photoIndex = (index + productImages.length) % productImages.length;
        mainImage.src = productImages[photoIndex];
        mainImage.alt = product.name + ", fotograf\xeda " + (photoIndex + 1) + ' de ' + productImages.length;
        document.getElementById('gallery-counter').textContent = photoIndex + 1 + ' / ' + productImages.length + " \xb7 Toca para ampliar";
        thumbs.forEach(function(thumb, index) {
            thumb.setAttribute('aria-pressed', String(index === photoIndex));
        });
    }
    thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
            showPhoto(Number(thumb.dataset.photo));
        });
    });
    gallery.querySelectorAll('[data-direction]').forEach(function(button) {
        button.addEventListener('click', function() {
            showPhoto(photoIndex + Number(button.dataset.direction));
        });
    });
    gallery.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            showPhoto(photoIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
    });
    gallery.querySelector('.gallery-image-button').addEventListener('click', function() {
        dialog.querySelector('img').src = productImages[photoIndex];
        dialog.querySelector('img').alt = mainImage.alt + ', ampliada';
        dialog.showModal();
    });
    dialog.querySelector('.dialog-close').addEventListener('click', function() {
        dialog.close();
    });
    dialog.addEventListener('click', function(event) {
        var rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    var related = (0, (/*@__PURE__*/$parcel$interopDefault($gYOZo))).filter(function(glove) {
        return glove !== product;
    }).sort(function(a, b) {
        return Number(b.category === product.category) - Number(a.category === product.category);
    }).slice(0, 3);
    $aabb1e7634dec432$var$container.closest('section').insertAdjacentHTML('afterend', '<section class="section related-products-section"><div class="container"><p class="section-label">Compara otras opciones</p><h2 class="section-title">Tambi\xe9n en el cat\xe1logo.</h2><div class="catalog-grid">' + related.map((0, $l7uIn.elementToCard)).join('') + '</div></div></section>');
    document.getElementById('product-jsonld').textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: product.name,
        description: description,
        url: pageUrl.href,
        image: productionImages,
        brand: {
            '@type': 'Brand',
            name: "Guantes Guti\xe9rrez"
        },
        manufacturer: {
            '@type': 'Organization',
            name: "Guantes Guti\xe9rrez"
        },
        additionalProperty: Object.entries(product.specs).map(function([name, value]) {
            return {
                '@type': 'PropertyValue',
                name: name,
                value: value
            };
        })
    });
    (0, $cVp72.initReveal)();
}


//# sourceMappingURL=producto.c64c310d.js.map
